module.exports = __webpack_public_path__ + "media/images/official/badge_202511-8a7b38363b34c797e8b22ab140099c59.svg";